module.exports = __webpack_public_path__ + "static/media/08_Hanna.dc51b0ef.png";